export default __webpack_public_path__ + "static/media/912.fc714e01.gif";